import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import GoogleIcon from '@/components/icons/svg/google-g-icon';
import { withStyles } from '@/decorators';
export const styles = ({ spacing, breakpoints }) => ({
    button: {
        alignItems: 'stretch',
        color: 'white',
        display: 'flex',
        fontFamily: 'Roboto',
        fontSize: spacing(3),
        [breakpoints.up('lg')]: {
            fontSize: spacing(3.5),
        },
        fontWeight: 500,
        height: '100%',
        width: '100%',
    },
    icon: {
        border: '2px solid #4285f4',
        fontSize: spacing(8.75),
    },
    text: {
        alignItems: 'center',
        background: '#4285f4',
        display: 'flex',
        paddingLeft: spacing(3),
        width: '100%',
    },
});
const GoogleSSOButton = withStyles(styles)(function GoogleSSOButton({ classes, ssoLogin, }) {
    return (<ButtonBase classes={{ root: classes.button }} onClick={ssoLogin}>
      <GoogleIcon classes={{ root: classes.icon }}/>
      <div className={classes.text}>Sign in with Google</div>
    </ButtonBase>);
});
export default GoogleSSOButton;
